import {
  Box,
  Divider,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { CustomText } from "@root/components/common/components";
import { getLoggedInUser } from "@root/store/selectors/entities";
import { isRouteExist } from "@root/utils/helpers";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { StyledProfileAvatar } from "./style";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";
import { ROUTE_NAMES } from "@root/constants/navigation-routes";
import { useNavigate } from "react-router-dom";
import { USER_TYPES } from "@root/constants";
import { LanguageToggle } from "./languagetoggle";
import useMediaQ from "@root/hooks/useMediaQ";
import { useGlobalContext } from "@root/context/global-context";
import { AddIcon, CloseIcon, DeleteIcon } from "@chakra-ui/icons";

export function NavControl({
  isOpen,
  isDarkTheme = false,
  menuItemsList = [],
  pathname,
  languages: systemLaguages = [],
  isMenuOpen,
  setIsMenuOpen,
  isSectionHeader = false,
}: any) {
  const user: any = useSelector(getLoggedInUser);
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const { sm } = useMediaQ();
  const isMobile = !sm;
  const { languagesOptions } = useGlobalContext();

  console.log("isOpen here", isOpen, isMenuOpen);

  const MenuContent = ({ ...props }) => {
    return (
      <MenuList
        gap={0}
        px={"6px"}
        boxShadow={"lg"}
        width={isMobile ? "320px" : "270px"}
        mr={"-6px"}
        position={"relative"}
        zIndex={9999}
        {...props}
        borderRadius={"16px"}
      >
        {/* Add profile */}
        <Flex justifyContent={"space-between"}>
          <Flex
            alignItems={"center"}
            gap={"16px"}
            p={"10px"}
            borderBottom="1px solid #E6E9EF"
          >
            <Box pl="10px">
              <StyledProfileAvatar
                name={user?.fullName || ""}
                src={user?.avatar}
              />
            </Box>
            <Flex
              userSelect={"none"}
              cursor={"pointer"}
              justifyContent={"start"}
              alignItems={"start"}
              gap={"6px"}
              flexDirection={"column"}
            >
              <CustomText
                noOfLines={1}
                fontSize={"14px"}
                textColor={"#0D0D0D"}
                fontWeight={500}
                text={user?.fullName || ""}
              />
              <CustomText
                noOfLines={1}
                fontSize={"12px"}
                fontWeight={400}
                textColor={"#5C6670"}
                text={user?.email || ""}
              />
              <CustomText
                fontSize={"14px"}
                fontWeight={500}
                color={"purple.500"}
                cursor="pointer"
                textDecoration="underline"
                mt="2px"
                onClick={() => {
                  if (user?.role === USER_TYPES.SUPER_ADMIN) {
                    navigate(ROUTE_NAMES.SUPER_ADMIN_PROFILE);
                  } else if (user?.role === USER_TYPES.ADMIN) {
                    navigate(ROUTE_NAMES.USER_PROFILE);
                  } else if (user?.role === USER_TYPES.JOURNALIST) {
                    navigate(ROUTE_NAMES.JOURNALIST_PROFILE);
                  } else if (
                    user?.role === USER_TYPES.SUBSCRIBER ||
                    user?.role === USER_TYPES.SUBSUBSCRIBER ||
                    user?.role === USER_TYPES.NON_SUBSCRIBER
                  ) {
                    navigate(ROUTE_NAMES.PLEDGE_PROFILE);
                  } else {
                    navigate(ROUTE_NAMES.JOURNALIST_PROFILE); // fallback or non-subscriber
                  }
                }}
                text={t("myProfile.viewProfile")}
              />
            </Flex>
          </Flex>
          {isMobile && (
            <CloseIcon
              mt={"15px"}
              mr={"15px"}
              boxSize={3}
              cursor="pointer"
              onClick={() => setIsMenuOpen(false)}
            />
          )}
        </Flex>
        {isMobile && isMenuOpen && languagesOptions?.length > 0 && (
          <Box p="10px" width={"180px"}>
            <LanguageToggle
              languages={languagesOptions}
              isSidebarOpen={true}
              marginBottom="0px"
              maxWidth="100%"
            />
          </Box>
        )}
        {menuItemsList.map((menu: any, index: number) => {
          return (
            <Box key={index}>
              {menu?.title === "hr" ? (
                <Divider my={"8px"} />
              ) : (
                <MenuItem
                  borderRadius={"8px"}
                  onClick={() => {
                    menu?.onClick();
                  }}
                  _hover={{
                    bg: "gray.100",
                    color: "purple.500",
                  }}
                  bg={
                    isRouteExist(pathname, menu?.routes)
                      ? "gray.100"
                      : "transparent"
                  }
                  color={
                    isRouteExist(pathname, menu?.routes)
                      ? "theme.button.primary"
                      : "theme.black.200"
                  }
                  icon={menu?.icon}
                  height={"55px"}
                  fontSize="16px"
                  fontWeight={400}
                >
                  {menu?.title}
                </MenuItem>
              )}
            </Box>
          );
        })}
      </MenuList>
    );
  };

  const ProfileContainter = () => {
    return (
      <Flex
        justifyContent={"space-between"}
        alignItems={"center"}
        position={"relative"}
        zIndex={1}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        cursor={"pointer"}
        bgColor={"theme.bg.doc"}
        p={"10px"}
        borderRadius={"md"}
        border={"1px solid #E6E9EF"}
      >
        {isOpen && (
          <>
            <Flex alignItems={"center"} width={"276px"} gap={"8px"}>
              <StyledProfileAvatar
                name={user?.fullName || ""}
                src={user?.avatar}
              />
              <Flex
                userSelect={"none"}
                cursor={"pointer"}
                justifyContent={"center"}
                alignItems={"center"}
                gap={"6px"}
              >
                <CustomText
                  fontSize={"14px"}
                  fontWeight={500}
                  isEllipse={true}
                  maxWidth="170px"
                  text={user?.email || ""}
                />
              </Flex>
            </Flex>
          </>
        )}
      </Flex>
    );
  };

  return (
    <Flex gap={"16px"} flexDir={"column"} padding={isOpen ? "2px" : "6px 0px"}>
      {isOpen && !isSectionHeader && (
        <Box
          data-tour-item={
            user?.role === USER_TYPES.ADMIN
              ? "admin-nav-control"
              : "journalist-nav-control"
          }
          mt={"-16px"}
          width={"100%"}
          bgColor={"theme.gray.zeroGray"}
          p={"8px"}
          border={"1px solid"}
          borderRadius={"8px"}
          borderColor={isDarkTheme ? "theme.gray.200" : "theme.gray.25"}
          flex={1}
        >
          <Menu
            placement="top-end"
            isOpen={isMenuOpen}
            onClose={() => setIsMenuOpen(false)}
          >
            <MenuButton
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              cursor={"pointer"}
              as={Box}
              width="100%"
            >
              <Flex
                alignItems="center"
                justifyContent="space-between"
                width="100%"
                gap="12px"
              >
                <StyledProfileAvatar
                  userSelect={"none"}
                  name={user?.fullName}
                  src={user?.avatar}
                />
                <Flex flexDir="column" flex={1} minWidth={0} ml="8px">
                  <Text
                    fontWeight={500}
                    fontSize={"16px"}
                    color={"#0D0D0D"}
                    className="clamped-text-1 clamped-text"
                    noOfLines={1}
                  >
                    {user?.fullName}
                  </Text>
                  <Text
                    fontWeight={300}
                    fontSize={"14px"}
                    color={"#0D0D0D"}
                    className="clamped-text-1 clamped-text"
                    noOfLines={1}
                  >
                    {user?.email || user?.loginId}
                  </Text>
                </Flex>
              </Flex>
            </MenuButton>
            <MenuContent
              ml={isMenuOpen ? "20px" : "0px"}
              mb={isMenuOpen ? "30px" : "0px"}
            />
          </Menu>
        </Box>
      )}
      {(!isOpen || isSectionHeader) && (
        <Box
          data-tour-item={
            user?.role === USER_TYPES.ADMIN
              ? "admin-nav-control"
              : "journalist-nav-control"
          }
          bgColor={isMobile ? "transparent" : ""}
          p={"8px"}
          border={"1px solid"}
          borderRadius={"8px"}
          borderColor={isDarkTheme ? "theme.gray.200" : "theme.gray.25"}
          flex={1}
        >
          <Menu
            placement="top-end"
            isOpen={isMenuOpen}
            onClose={() => setIsMenuOpen(false)}
          >
            <MenuButton
              onClick={() => {
                setIsMenuOpen(!isMenuOpen);
              }}
              cursor={"pointer"}
              as={Box}
              width="100%"
              bgColor={isMobile ? "transparent" : ""}
            >
              <Flex alignItems="center" justifyContent="center" width="100%">
                <StyledProfileAvatar
                  userSelect={"none"}
                  name={user?.fullName}
                  src={user?.avatar}
                />
              </Flex>
            </MenuButton>
            <MenuContent
              ml={isMenuOpen ? "20px" : "0px"}
              mb={isMenuOpen ? "30px" : "0px"}
            />
          </Menu>
        </Box>
      )}
    </Flex>
  );
}
